import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  const categoryIcons = {
    'All': 'Grid3X3',
    'Market Analysis': 'TrendingUp',
    'Authentication': 'Shield',
    'Community': 'Users',
    'Collecting Tips': 'Lightbulb',
    'Auction Results': 'Gavel',
    'Industry News': 'Newspaper',
    'Expert Insights': 'Award'
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="text-sm font-semibold text-card-foreground mb-3 flex items-center space-x-2">
        <Icon name="Filter" size={16} />
        <span>Categories</span>
      </h3>
      <div className="space-y-1">
        {categories?.map((category) => (
          <button
            key={category?.name}
            onClick={() => onCategoryChange(category?.name)}
            className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 premium-hover ${
              selectedCategory === category?.name
                ? 'bg-primary/10 text-primary border border-primary/20' :'text-muted-foreground hover:text-card-foreground hover:bg-muted/50'
            }`}
          >
            <div className="flex items-center space-x-3">
              <Icon 
                name={categoryIcons?.[category?.name] || 'Tag'} 
                size={16}
                className={selectedCategory === category?.name ? 'text-primary' : 'text-muted-foreground'}
              />
              <span>{category?.name}</span>
            </div>
            <span className={`text-xs px-2 py-1 rounded-full ${
              selectedCategory === category?.name
                ? 'bg-primary/20 text-primary' :'bg-muted/50 text-muted-foreground'
            }`}>
              {category?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;